module.exports = __webpack_public_path__ + "static/media/trang.d50ce373.png";